<template>
  <header>
    <b-navbar toggleable="md" ttype="light" variante="light" id="m68_navbar_top">
      <b-navbar-toggle target="m68_nav_collapse_top"></b-navbar-toggle>
      <b-navbar-brand href="/">
        <img src="@/assets/logo.png" alt="Axel Springer Logo">
      </b-navbar-brand>
      <b-collapse is-nav id="m68_nav_collapse_top">
        <b-navbar-nav id="m68_navbar_top_nav">
          <b-nav-item :to="{ name: item.route }" v-for="(item, index) in menuItems" :key="index" :exact="true">
            {{ item.label }}
          </b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-form right>
            <input
              type="text"
              placeholder="Suchbegriff eingeben"
              class="mr-sm-1 form-control form-control-sm"
              @keyup.enter="simpleSearch" 
              v-model="keywords"
            />
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-container>
      <b-row>
        <b-col>
          <img src="@/assets/9327332_89da99e9a6.jpg" class="mb-4" height="90" width="880" />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <ol class="breadcrumb m68_breadcrumb">
            <li class="text-muted">Sie befinden sich hier:&nbsp;</li>
            <template v-for="(item, index) in breadcrumbs">
              <li v-if="item.to" role="presentation" class="breadcrumb-item" :key="index">
                <b-link :to="item.to" target="_self">{{ item.text }}</b-link>
              </li>
              <li v-else role="presentation" class="breadcrumb-item" :key="index">
                <span>{{ item }}</span>
              </li>
            </template>
          </ol>
          <!--<b-breadcrumb :items="breadcrumbs" class="m68_breadcrumb" />-->
        </b-col>
      </b-row>
    </b-container>
  </header>
</template>

<script>
  import store from '@/store'

  export default {
    name: 'Navigation',
    data() {
      return {
        keywords: ""
      }
    },
    computed: {
      menuItems () {
        return [
          {
            label: 'Startseite',
            route: 'home'
          },
          {
            label: 'Über das Archiv',
            route: 'about'
          },
          {
            label: 'Medienarchiv',
            route: 'archive'
          },
          {
            label: 'Pressespiegel',
            route: 'press'
          },
          {
            label: 'Kontakt',
            route: 'contact'
          }
        ]
      },
      breadcrumbs () {
        return store.state.navigation.breadcrumbs
      },
      getActivePage () {
        return store.state.navigation.active
      }
    },
    methods: {
      simpleSearch() {
        store.dispatch('updateSearch', { keywords: this.keywords })

        this.$router.push({
          name: 'archive',
          params: {
            inlineSearch: true
          }
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue